customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('sc-recommendations-carousel')) return;

  const NativeSlider = customElements.get('slider-component');

  class RecommendationsCarousel extends NativeSlider {
    connectedCallback() {
      if (this.recommendationEvents) return;
      this.track = this.querySelector('.splide__track');
      if (!this.track) return;
      this.originalTabIndex = this.track.getAttribute('tabindex');
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      const passive = { capture: true, passive: true };
      this.recommendationEvents = [
        [this, 'pointerdown', (event) => this.startGesture(event), passive],
        [this, 'pointermove', (event) => this.moveGesture(event), passive],
        [this, 'pointerup', (event) => this.endGesture(event), passive],
        [this, 'pointercancel', (event) => this.endGesture(event), passive],
        [this, 'click', (event) => this.guardClick(event), { capture: true }],
        [this.track, 'scroll', () => this.observeScroll(), { passive: true }],
        [this.track, 'keydown', (event) => this.navigateTrack(event)],
      ];
      this.recommendationEvents.forEach(([target, type, listener, options]) => {
        target.addEventListener(type, listener, options);
      });
      this.changeMode = () => this.syncMode();
      if (this.desktopQuery.addEventListener) this.desktopQuery.addEventListener('change', this.changeMode);
      else this.desktopQuery.addListener(this.changeMode);
      this.syncMode();
    }

    syncMode() {
      this.gesture = null;
      if (this.desktopQuery.matches) {
        if (this.originalTabIndex === null) this.track.removeAttribute('tabindex');
        else this.track.setAttribute('tabindex', this.originalTabIndex);
        if (!this.desktopMounted) {
          super.connectedCallback();
          this.desktopMounted = true;
        }
      } else {
        this.unmountDesktop();
        this.track.setAttribute('tabindex', '0');
      }
    }

    unmountDesktop() {
      if (!this.desktopMounted) return;
      this.slider?.destroy(true);
      super.disconnectedCallback();
      this.slider = null;
      this.desktopMounted = false;
    }

    startGesture(event) {
      if (this.desktopQuery.matches || event.isPrimary === false) return;
      this.gesture = null;
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      this.gesture = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        scroll: this.track.scrollLeft,
        moved: false,
        ended: false,
      };
    }

    moveGesture(event) {
      const gesture = this.gesture;
      if (!gesture || gesture.ended || event.pointerId !== gesture.id) return;
      const horizontal = Math.abs(event.clientX - gesture.x);
      const vertical = Math.abs(event.clientY - gesture.y);
      if (horizontal > 8 && horizontal > vertical) gesture.moved = true;
    }

    endGesture(event) {
      if (!this.gesture || event.pointerId !== this.gesture.id) return;
      this.observeScroll();
      this.gesture.ended = true;
    }

    observeScroll() {
      if (!this.gesture || this.desktopQuery.matches) return;
      if (Math.abs(this.track.scrollLeft - this.gesture.scroll) > 6) this.gesture.moved = true;
    }

    guardClick(event) {
      const gesture = this.gesture;
      if (this.desktopQuery.matches || !gesture) return;
      this.observeScroll();
      this.gesture = null;
      if (event.detail === 0 || !gesture.moved || !gesture.ended) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    navigateTrack(event) {
      if (this.desktopQuery.matches || event.target !== this.track) return;
      const firstCard = this.track.querySelector('.product-recommendations__slide');
      if (!firstCard) return;
      const nextCard = firstCard.nextElementSibling;
      const step = nextCard ? nextCard.offsetLeft - firstCard.offsetLeft : firstCard.offsetWidth;
      let left;
      if (event.key === 'ArrowRight') left = this.track.scrollLeft + step;
      else if (event.key === 'ArrowLeft') left = this.track.scrollLeft - step;
      else if (event.key === 'Home') left = 0;
      else if (event.key === 'End') left = this.track.scrollWidth - this.track.clientWidth;
      else return;
      event.preventDefault();
      this.track.scrollTo({ left, behavior: 'auto' });
    }

    disconnectedCallback() {
      this.recommendationEvents?.forEach(([target, type, listener, options]) => {
        target.removeEventListener(type, listener, options);
      });
      if (this.desktopQuery?.removeEventListener) this.desktopQuery.removeEventListener('change', this.changeMode);
      else this.desktopQuery?.removeListener(this.changeMode);
      this.recommendationEvents = null;
      this.unmountDesktop();
      if (this.track) {
        if (this.originalTabIndex === null) this.track.removeAttribute('tabindex');
        else this.track.setAttribute('tabindex', this.originalTabIndex);
      }
      this.gesture = null;
    }
  }

  customElements.define('sc-recommendations-carousel', RecommendationsCarousel);
});
